import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

// spacer size
var navHeight = $('.nav_mobile_e3f1').height();
console.log(" navHeight: " + navHeight);
if(window.innerWidth < 783) {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight + 'px'})
}

function openMenu() {
  //disableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').addClass('active');
  $('.nav_mobile_e3f1').addClass('active');
  $('.nav_mobile_e3f1__trigger').text('Close');
  $('html').addClass('no_scroll');
  // $('.content_df8c').addClass('page_noscroll');
  // $('.footer_desktop_baa5').addClass('page_noscroll');
  
}

function closeMenu() {
  //enableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').removeClass('active');
  $('.nav_mobile_e3f1').removeClass('active');
  $('.nav_mobile_e3f1__trigger').text('Menu');
  $('html').removeClass('no_scroll');
  // $('.content_df8c').removeClass('page_noscroll');
  // $('.footer_desktop_baa5').removeClass('page_noscroll');
}

$('.nav_mobile_e3f1__trigger').on('click', function(e){
  e.preventDefault();
  if($(this).hasClass('active')) {
    closeMenu();
  } else {
    openMenu();
  }
});

$('.nav_mobile_e3f1__menu .menu_item_open').on('click', function(){
  jQuery('.menu_item').removeClass('active');
  var $li = $(this).parent();
  if($li.hasClass('active')) {
    $li.removeClass('active');
  } else {
    $li.addClass('active');
  }
});